import { URL } from '../constants';
import { apiInstance } from '../instance';

export const getUnreadCount = (hospitalId: number) =>
  apiInstance.get(
    URL.GET_UNREAD_VOICE_MAIL_COUNT.replace('{hospital_id}', String(hospitalId))
  );
